export const createKeyboardListener = ({ handler }) => {
  const onKeyDown = (ev) => {
    if (handler) {
      handler(ev);
    }
  };

  const addListener = () => {
    if (typeof document === "undefined") return;
    document.addEventListener("keydown", onKeyDown);
  };

  const removeListener = () => {
    if (typeof document === "undefined") return;
    document.removeEventListener("keydown", onKeyDown);
  };

  return { addListener, removeListener };
};
